/**
 * Hamburger Menu Icon Component
 *
 * Three-line hamburger menu icon for mobile navigation.
 * Figma: Hamburger Icon (Node: 895:24086)
 *
 * Dimensions: 20px × 20px
 * Colors: Black (#000000)
 */
"use client";

import Image from "next/image";

interface HamburgerIconProps {
  className?: string;
  onClick?: () => void;
}

export function HamburgerIcon({ className = "", onClick }: HamburgerIconProps) {
  return (
    <button
      onClick={onClick}
      className={`relative flex h-5 w-5 items-center justify-center transition-opacity hover:opacity-70 ${className}`}
      aria-label="Open menu"
    >
      <Image src="/icons/hamburger.svg" alt="" width={20} height={20} />
    </button>
  );
}
